export default "__VITE_ASSET__BDYupSZV__"